<template>
  <div class="progress">
    <div class="percent" :style="`width: ${percent}%`"></div>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.progress {
  width: 100%;
  height: 5px;
  background-color: #f1f2f4;
  border-radius: 3px;
  .percent {
    background-color: #fe4f4c;
    height: 100%;
    border-radius: 3px;
  }
}
</style>
